import React from 'react';
import './chip.styles.scss';
import Button from '@/components/button/button.component';

interface Props {
  onClick?: () => void;
  isActive?: boolean;
  label: string;
  isClickable?: boolean;
  className?: string;
}

const Chip: React.FC<Props> = ({ onClick, isActive, label, className, isClickable = true }) => {
  if (isClickable) {
    return (
      <Button
        onClick={onClick}
        className={`chip ${isActive ? 'chip--active' : ''}`}
        label={label}
        aria-pressed={!!isActive}
      />
    );
  } else {
    return <span className={`chip ${className ?? ''}`}>{label}</span>;
  }
};

export default Chip;
